import "./index.css";
import React from "react";
import ReactDOM from "react-dom/client";
import { App } from "./App";
import { initMetaPixel } from "./utils/metaPixel";
initMetaPixel();
const rootEl = document.getElementById("root");
if (rootEl) {
  ReactDOM.createRoot(rootEl).render(<App data-id="element-381" data-mp="21cacxxxtztcm" />);
}